export default __webpack_public_path__ + "static/media/1_box.5011401d.png";